import { type DataObject } from './DataObject'

export enum UserType {
  STUDENT = 'STUDENT',
  INSTRUCTOR = 'INSTRUCTOR',
  ADMIN = 'ADMIN'
}

export enum EmailLanguage {
  EN = 'EN',
  ES = 'ES',
  PT = 'PT',
}

export interface SlotEmailSettings {
  slotEmailSettingsId: string
  slotId: string
  emailType: string
  customMessage: string
  daysBefore: number
  enabled: boolean
  title: string
  description: string
  userType: UserType
  settingType: 'DAYS_BEFORE' | 'REMINDER_INTERVAL'
  reminderInterval: number
  language: EmailLanguage | null
  nextEmailPushTimestamp?: string | null
  lastEmailSentTimestamp?: string | null
}

export type SlotEmailSettingsApiResponse = DataObject<SlotEmailSettings>
